export default __webpack_public_path__ + "9c08f604effad0784d9b328e7a752036.png";